module.exports = "pegasus_template/assets/themelp1/small/27.png";